module.exports = __webpack_public_path__ + "img/domain-banner-security.1a47f2e3.svg";